/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * One movement search for the whole dashboard (layout/Sidebar mounts it).
 * `log` opens the chosen movement's page with its Log result dialog open.
 */
export const OPEN_MOVEMENT_SEARCH_EVENT = "lt:open-movement-search";

export interface OpenMovementSearchDetail {
  log?: boolean;
}

export function openMovementSearch(detail: OpenMovementSearchDetail = {}): void {
  window.dispatchEvent(new CustomEvent(OPEN_MOVEMENT_SEARCH_EVENT, { detail }));
}
